import { render, staticRenderFns } from "./PlayerResourceLog.vue?vue&type=template&id=989a58c0&scoped=true&"
import script from "./PlayerResourceLog.vue?vue&type=script&lang=js&"
export * from "./PlayerResourceLog.vue?vue&type=script&lang=js&"
import style0 from "./PlayerResourceLog.vue?vue&type=style&index=0&id=989a58c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989a58c0",
  null
  
)

export default component.exports